export const LOADING = "LOADING";
export const GET_ITEMS = "GET_ITEMS";
export const SET_ITEM = "SET_ITEM";
export const SET_DEFAULT_ITEMS = "SET_DEFAULT_ITEMS";
export const RESET_CART = "RESET_CART";
export const SET_CART = "SET_CART";
